import { CreateOrderInput } from '@/validators/create-orderInfo.schema';

export function defaultValues(shipment?: CreateOrderInput) {
  return {
    country: shipment?.country ?? '',
    agency: shipment?.agency ?? '',
    packageInfoAttachment: shipment?.packageInfoAttachment ?? undefined,
    shippingInfoAttachment: shipment?.shippingInfoAttachment ?? undefined,
    officeOrigin: shipment?.officeOrigin ?? '',
    shippingMethod: shipment?.shippingMethod ?? '',
    packagingType: shipment?.packagingType ?? '',
    courierCompany: shipment?.courierCompany ?? '',
    deliveryTime: shipment?.deliveryTime ?? '',
    senderName: shipment?.senderName ?? '',
    senderAddress: shipment?.senderAddress ?? '',
    senderEmail: shipment?.senderEmail ?? '',
    senderPhone: shipment?.senderPhone ?? '',
    notifySenderViaSMS: shipment?.notifySenderViaSMS ?? false,
    recipientName: shipment?.recipientName ?? '',
    recipientAddress: shipment?.recipientAddress ?? '',
    recipientEmail: shipment?.recipientEmail ?? '',
    recipientPhone: shipment?.recipientPhone ?? '',
    notifyRecipientViaSMS: shipment?.notifyRecipientViaSMS ?? false,
    paidBy: shipment?.paidBy ?? '',
    paymentMethod: shipment?.paymentMethod ?? '',
    paymentType: shipment?.paymentType ?? '',
    payeeName: shipment?.payeeName ?? '',
    payeeCountry: shipment?.payeeCountry ?? '',
    payeeCity: shipment?.payeeCity ?? '',
    payeeStreetAddress: shipment?.payeeStreetAddress ?? '',
    packageAmount: shipment?.packageAmount ?? '',
    packageWidth: shipment?.packageWidth ?? '',
    packageHeight: shipment?.packageHeight ?? '',
    packageLength: shipment?.packageLength ?? '',
    packageWeight: shipment?.packageWeight ?? '',
    packageDescription: shipment?.packageDescription ?? '',
    giftType: shipment?.giftType ?? '',
    giftFrom: shipment?.giftFrom ?? '',
    giftTo: shipment?.giftTo ?? '',
    giftMessage: shipment?.giftMessage ?? '',
  };
}

export const shipmentData = {
  agency: 'pixelperfect',
  country: 'US',
  courierCompany: 'fedex',
  deliveryTime: 'next_day',
  notifySenderViaSMS: true,
  notifyRecipientViaSMS: true,
  officeOrigin: 'NY-NY/USA',
  paidBy: 'Sender',
  paymentMethod: 'credit_card',
  packagingType: 'carton',
  paymentType: 'payNow',
  payeeName: 'Nicolas Dover',
  payeeCountry: 'US',
  payeeCity: 'Dallas',
  payeeStreetAddress: '3607 Oakridge Lane',
  packageAmount: '4500',
  packageWidth: '123',
  packageHeight: '321',
  packageLength: '456',
  packageWeight: '654',
  recipientName: 'Salvador Patton',
  recipientAddress: '4266 Primrose Lane, Madison, Wisconsin, 53703',
  recipientEmail: 'salvoor@gmail.com',
  recipientPhone: '+13478903219',
  shippingMethod: 'express',
  shippingInfoAttachment: undefined,
  senderName: 'Rylee Wheeler',
  senderAddress: '4348 Tuna Street, Columbiaville, Michigan, 48421',
  senderEmail: 'ryleewheeler@gmail.com',
  senderPhone: '+13478901234',
};
